import React, { PropsWithChildren, ReactNode } from 'react'
import { Link } from 'react-router'

import {
  Flex,
  FlexAnchor,
  Header,
  HeaderLowerContent,
  HeaderSubtitle,
  HeaderTitle,
  HeaderUpperContent,
  Icon,
  LinkAnchor,
  MainSection,
  MainSectionProps,
  WideContainer,
} from '../atoms'
import { AnimatedPage } from './AnimatedPage'

export interface FullPageTemplateProps
  extends PropsWithChildren,
    Pick<MainSectionProps, 'variant'> {
  pageId?: string
  upperHeader?: ReactNode
  header: ReactNode
  subheader?: ReactNode
  lowerHeader?: ReactNode
  footer?: ReactNode
  upButton?: {
    to: string
    text: string
  }
}

export const FullPageTemplate = ({
  pageId,
  upButton,
  upperHeader,
  header,
  subheader,
  lowerHeader,
  children,
  footer,
  variant,
}: FullPageTemplateProps) => {
  const backButtonComponent = upButton && (
    <Flex width={1}>
      <FlexAnchor
        fontFamily='buttons'
        mb={10}
        as={Link}
        to={upButton.to}
        relative='route'
        data-testid='link-back'
      >
        <Icon color='hyperlink' size='medium' pl={2} icon='chevronRight' rotate={180} />
        <LinkAnchor as='span' typoSize='sm' variant='standalone'>
          {upButton.text}
        </LinkAnchor>
      </FlexAnchor>
    </Flex>
  )

  const upperComponent = upperHeader && (
    <HeaderUpperContent>{upperHeader}</HeaderUpperContent>
  )

  const lowerComponent = lowerHeader && (
    <HeaderLowerContent>{lowerHeader}</HeaderLowerContent>
  )

  const subheaderComponent = subheader && <HeaderSubtitle>{subheader}</HeaderSubtitle>

  return (
    <AnimatedPage pageId={pageId} footer={footer}>
      <WideContainer>
        <MainSection variant={variant}>
          <Header width={1}>
            {backButtonComponent}
            {upperComponent}
            <HeaderTitle>{header}</HeaderTitle>
            {subheaderComponent}
            {lowerComponent}
          </Header>
          {children}
        </MainSection>
      </WideContainer>
    </AnimatedPage>
  )
}
